import { render, staticRenderFns } from "./AssistanceModal.vue?vue&type=template&id=35b78e27&"
import script from "./AssistanceModal.vue?vue&type=script&lang=js&"
export * from "./AssistanceModal.vue?vue&type=script&lang=js&"
import style0 from "./AssistanceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports